import { action, payload } from 'ts-action'
import { IGigTypeExperience } from '@network/models/experience.model'
import { IError, IPayload } from '@network/models/global.model'

export const GigTypeExperiencesFetching = action(
  'GigTypeExperiencesFetching',
  payload<boolean>(),
)

export const GetGigTypeExperiences = action(
  'GetGigTypeExperiences',
  payload<IPayload<IGigTypeExperience[]>>(),
)

export const GetGigTypeExperiencesErrors = action(
  'GetGigTypeExperiencesErrors',
  payload<IError>(),
)
